import { useEffect } from 'react';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import MuiTablePagination from '@mui/material/TablePagination';

import { FORTA_GRAY4, FORTA_BLUE } from '../../../utils/colors';

import type { MouseEvent } from 'react';

const rowsPerPageOptions = [10, 20, 50, 100];

interface BillingHistoryTableFooterProps {
  count: number;
  page: number;
  rowsPerPage: number;
  docType: string;
  changeRowsPerPage: (page: string | number) => void;
  changePage: (newPage: number) => void;
}

const HistoricalDocumentTableFooter = ({
  count,
  page,
  rowsPerPage,
  docType,
  changeRowsPerPage,
  changePage,
}: BillingHistoryTableFooterProps) => {
  useEffect(() => {
    const savedRowsPerPage = sessionStorage.getItem(`historical-${docType}-items-per-page`);
    if (savedRowsPerPage) {
      changeRowsPerPage(+savedRowsPerPage);
    }

    const savedPage = sessionStorage.getItem(`historical-${docType}-page`);
    if (savedPage) {
      const pageNumber = Number(savedPage);
      if (!Number.isNaN(pageNumber)) {
        changePage(pageNumber);
      }
    }
  }, [docType]);

  const handleRowChange = (value: string | number) => {
    sessionStorage.setItem(`historical-${docType}-items-per-page`, String(value));
    changeRowsPerPage(value);
  };

  const handlePageChange = (page: number) => {
    sessionStorage.setItem(`historical-${docType}-page`, String(page));
    changePage(page);
  };

  const footerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0px 24px 0px 24px',
  };

  return (
    <TableFooter>
      <TableRow>
        <TableCell style={footerStyle}>
          <MuiTablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            rowsPerPageOptions={rowsPerPageOptions}
            onPageChange={(_: MouseEvent<HTMLButtonElement> | null, page: number) =>
              handlePageChange(page)
            }
            onRowsPerPageChange={(e) => handleRowChange(e.target.value)}
            showFirstButton
            showLastButton
            sx={{
              '.MuiTablePagination-toolbar': {
                color: FORTA_GRAY4,
                height: '36px',
              },
              '.MuiTablePagination-displayedRows': {
                marginBottom: 0,
              },
              '.MuiTablePagination-selectLabel': {
                marginBottom: 0,
              },
              '.MuiTablePagination-input': {
                padding: 1,
                backgroundColor: FORTA_BLUE.light3,
                borderRadius: '10px',
              },
              '.MuiButtonBase-root': {
                margin: '0 10px',
                backgroundColor: FORTA_BLUE.light3,
              },
            }}
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default HistoricalDocumentTableFooter;
